import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WxAppointmentUserInfo from '@/types/table/wxAppointmentUserInfo';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WxAppointmentUserInfoData extends WxAppointmentUserInfo {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WxAppointmentUserInfoController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WxAppointmentUserInfoData>>(API_CONTEXT + '/app/wxAppointmentUserInfo/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WxAppointmentUserInfoData>(API_CONTEXT + '/app/wxAppointmentUserInfo/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wxAppointmentUserInfo/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wxAppointmentUserInfo/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wxAppointmentUserInfo/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wxAppointmentUserInfo/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wxAppointmentUserInfo/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wxAppointmentUserInfo/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wxAppointmentUserInfo/deleteBatch', params, httpOptions);
  }
  static setAdmin(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wxAppointmentUserInfo/setAdmin', params, httpOptions);
  }
  static cancelAdmin(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wxAppointmentUserInfo/cancelAdmin', params, httpOptions);
  }
}
